import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { profileSelectors } from '../../../../store/selectors/profile';
import { editUserInfoThunk } from '../../../../store/thunks/profile';
import { authSelectors } from '../../../../store/selectors/auth';
import actions from '../../../../store/actions';

import Field from '../../../../common/Fields/Field';
import LoadingBtn from '../../../LoadingBtn/LoadingBtn';
import ErrorMessage from '../../../../common/Errors/ErrorMessage';

const MiddleNameForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const profile = useSelector(profileSelectors);
  const auth = useSelector(authSelectors);
  const token = auth.token;
  const user = profile.user;
  const errors = profile.errors;
  const load = profile.load;
  const edit = profile.edit;
  const confirmInfo = profile.confirmInfo;

  const [middleName, setMiddleName] = useState('');
  const [fieldConfirmed, setFieldConfirmed] = useState('');

  useEffect(() => {
    if(Object.keys(user).length && user.mid_name) {
      setMiddleName(user.mid_name);
    }
  }, [user]);

  useEffect(() => {
    if(edit) {
      navigate('/profile');
      dispatch(actions.profile.editUserInfo(false));
      dispatch(actions.profile.profileError({}));
    }
  }, [edit]);

  useEffect(() => {
    if(confirmInfo.length > 0) {
      setFieldConfirmed(confirmInfo.find(field => field.field === 'mid_name'));
    }
  }, [confirmInfo]);

  useEffect(() => {
    if(fieldConfirmed) {
      setMiddleName(fieldConfirmed.value_to);
    }
  }, [fieldConfirmed]);

  const handleEdit= (e) => {
    e.preventDefault();
    dispatch(editUserInfoThunk({value: middleName, field: 'mid_name', token}));
  };
  
  return (
    <form className='form profile-form'>
      <Field 
        name="middle_name" 
        type="text"
        value={middleName}
        labelText="По батькові" 
        onChange={(e) => setMiddleName(e.target.value.trim())} 
        formClass="form__field required"
        required
      />

      {errors?.value &&  errors.value.map(err => <ErrorMessage key={err} errorText={err} />)}

      <div className="profile__btns">
        <LoadingBtn load={load} btnText='Змінити' onClick={handleEdit} />
      </div>
    </form>
  );
};

export default MiddleNameForm;